module.exports = __webpack_public_path__ + "static/media/seaside.956f8e7d.mp3";